export default "__VITE_ASSET__I1e2KXLC__"